<template>
  <page-outline :title="$t('businessDocuments.form_document_send_title')"
    icon="icon-sent" returnUrl="/home/">
    <template slot="pageContent">

      <div v-if="!isSmartphoneOS">

        <!-- File Type -->
        <form-accordion :title="$t('attachments.file')">
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input isMandatory
                :idLabel="$t('businessDocuments.document_type')"
                :inputType="'listeSelect'" :mandatoryErrorIndicator="fileTypeSelectedError">
                <select class="form-control" id="sel2" readonly v-model="fileTypeSelected"
                  @change="setSerialize">
                  <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
                  <option v-for="fileType in fileTypeList" :key="fileType.fileTypeValue"
                    :disabled="fileType.disabled"
                    :value="fileType.fileTypeValue"
                    :style="fileType.disabled ? 'font-style:italic;' : ''">
                    {{ $t(fileType.fileTypeLabel) }}
                  </option>
                </select>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="requestName" isMandatory
                :idLabel="$t('businessDocuments.request_name_send_doc')"
                :placeholderValue="$t('businessDocuments.request_name_send_doc_placeholder')"
                :mandatoryErrorIndicator="requestNameError">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="fileReference"
                :idLabel="$t('common.rfrnc')"
                :placeholderValue="$t('common.rfrnc_desc')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="creationDate"
                :inputType="'date'"
                :idLabel="$t('businessDocuments.creation_date')"
                :placeholderValue="$t('common.slct_date')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>

        <hr/>

        <!--File Location -->
        <form-accordion :title="$t('businessDocuments.file_location')" :star="true">
          <!-- <b-form-group>
            <b-form-radio class="creationFormBtnRadio" v-model="locationTypeFile"
                          name="radios-locationTypeFile" value="1">{{ $t('common.local_location') }}
            </b-form-radio>&nbsp;&nbsp;
            <b-form-radio style='margin-left: 35px;' class="creationFormBtnRadio" v-model="locationTypeFile"
                          :disabled="$engine.rights.rightIs('attachment_consulter', false)"
                          name="radios-locationTypeFile" value="2">{{ $t('common.moneyroad_location') }}
            </b-form-radio>
            <i style="float:right" v-if='this.fileNameArray.length != 0'>{{ $t('businessDocuments.othr_pages_label') }}</i>
          </b-form-group> -->

          <b-row>
            <b-col sm="12" lg="6" class="form-group">
              <b-row v-if="locationTypeFile === '1'">
                <b-col class="form-group">
                  <f7-button round class="invoiceButton buttonAccordionForm generalBottomButton"
                    @click="showFileSelectionWindow(locationTypeFile)">
                    {{ $t('attachments.import_file_singular') }}
                  </f7-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="form-group">
                  <select class="form-control" id="sel2" readonly v-model="fileId"
                          v-if='locationTypeFile === "2"' @change="loadCloudFile()">
                    <option value="" default disabled>
                      {{ this.hasCloudAttachments ? $t('creation_forms.slct_a_fl') : $t('attachments.no_document') }}
                    </option>
                    <option v-for="cloudDoc in cloudDocs" :key="cloudDoc.id" :value="cloudDoc.id">
                      {{ cloudDoc.name }}
                    </option>
                  </select>
                  <input class="item-input hiddenElementAllSize local-file-input" ref="fileButton" @change="executeOCR" type="file"/>
                  <input class="hiddenElementAllSize" type="text"></input>
                  <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
                  <div v-if="fileArrayError" style='color:red;'>
                    {{ $t('errors.is_mandatory', {mandatoryValue: $t('attachments.import_file_singular') }) }}
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="this.fileNameArray.length != 0" sm="12" lg="6" class="form-group">
              <table class="table table-striped table-bordered" style="table-layout:fixed">
                <thead>
                  <tr>
                    <th scope="col" style="width:70%">{{ $t('businessDocuments.document_lst') }}</th>
                    <th scope="col">{{ $t('common.action_label') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="filename in this.fileNameArray">
                    <td class="textOverflow">{{ filename }}</td>
                    <td>
                      <a href="#" @click="removeFile(filename)">
                        <i class="icon button-delete f7-icons">close</i>
                        <span class="labelDelete">{{ $t('common.rm_label') }}</span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </form-accordion>

      </div>
      <div v-if="isSmartphoneOS">

        <b-row>
          <b-col>
            <f7-button class="button-action-main greenButton"
              :title="$t('creation_forms.tke_doct_pctr')"
              @click="scanDocument($event)">
              <span>{{ $t('creation_forms.tke_doct_pctr') }}</span>
            </f7-button>
          </b-col>
        </b-row>

        <b-row>
          <span class="labelSub greyLabel">{{ $t('common.or_label_maj') }}</span>
        </b-row>
        <b-row class="form-group">
          <b-col>
            <f7-button class="button-action-sub greyButton"
              :title="$t('businessDocuments.local_location_small')"
              :disabled="$engine.rights.rightIs('attachment_consulter', false)"
              @click="showFileSelectionWindow('1')">
              <span>{{ $t('businessDocuments.local_location_small') }}</span>
            </f7-button>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <b-col>
            <f7-button class="button-action-sub greyButton"
              :title="$t('businessDocuments.moneyroad_location_small')"
              @click="filesPicker($event)">
              <span>{{ $t('businessDocuments.moneyroad_location_small') }}</span>
            </f7-button>
          </b-col>
        </b-row>

        <!-- File Type -->
        <b-row>
          <b-col sm="6" class="form-group" v-if='this.locationTypeFile != "0" && false'>
            <label>{{ $t('businessDocuments.document_name') }}</label>
            <input class="form-control inputAccordionForm" type="text"
              :placeholder="$t('creation_forms.slct_a_fl')"
              readonly
              id="application-file-input-mobile"
              v-model="fileNameLabel">
            </input>
          </b-col>
          <b-col sm="12" class="form-group" v-if='this.fileNameArray.length != 0'>
            <i>{{ $t('businessDocuments.othr_pages_label') }}</i>
            <table class="table table-striped table-bordered" style="table-layout:fixed">
              <thead>
                <tr>
                  <th scope="col" style="width:70%">{{ $t('businessDocuments.document_lst') }}</th>
                  <th scope="col">{{ $t('common.action_label') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="filename in this.fileNameArray">
                  <td class="textOverflow">{{ filename }}</td>
                  <td>
                    <a href="#" @click="removeFile(filename)">
                      <i class="icon button-delete f7-icons">close</i>
                      <span class="labelDeleteMobile">{{ $t('common.rm_label') }}</span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <input class="item-input hiddenElementAllSize local-file-input" @change="executeOCR" type="file"/>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input isMandatory
              :idLabel="$t('businessDocuments.document_type')"
              :inputType="'listeSelect'" :mandatoryErrorIndicator="fileTypeSelectedError">
              <select class="form-control" id="sel2" readonly v-model="fileTypeSelected"
                @change="setSerialize">
                <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
                <option v-for="fileType in fileTypeList" :key="fileType.fileTypeValue"
                  :disabled="fileType.disabled"
                  :style="fileType.disabled ? 'font-style:italic;' : ''"
                  :value="fileType.fileTypeValue">
                  {{ $t(fileType.fileTypeLabel) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="requestName" isMandatory
              :idLabel="$t('businessDocuments.request_name')"
              :placeholderValue="$t('businessDocuments.request_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="fileReference"
              :idLabel="$t('common.rfrnc')"
              :placeholderValue="$t('common.rfrnc')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="creationDate"
              :inputType="'date'"
              :idLabel="$t('businessDocuments.creation_date')"
              :placeholderValue="$t('common.slct_date')">
            </form-write-group-label-input>
          </b-col>
        </b-row>

      </div>

      <hr />

      <!-- Document Information -->
      <div v-if="this.serializeGet.length != 0">
        <form-accordion :title="$t('businessDocuments.doc_details')" :open="ocrDone">
          <b-row>
            <template v-for="value in serializeGet">
              <template v-if="(value.change === '1' && serialize[value.name] !== '') || (value.change === '0' && serialize[value.name])">
                <template v-if="value.type === 'object'">
                  <b-col sm="6" class="form-group" v-for="(subvalue, subindex) in value[0]" :key="subindex">
                    <form-write-group-label-input
                      v-model="serialize[value.name][0][subindex.name]"
                      :idLabel="$t('businessDocuments.serialize.' + fileTypeSelected + '.' + subindex.name)">
                    </form-write-group-label-input>
                  </b-col>
                </template>
                <b-col sm="6" class="form-group" v-else-if="value.type === 'date'">
                  <form-write-group-label-input v-model="serialize[value.name]"
                    :inputType="'date'"
                    :idLabel="$t('businessDocuments.serialize.' + fileTypeSelected + '.' + value.name)"
                    :placeholderValue="$t('common.slct_date')">
                  </form-write-group-label-input>
                </b-col>
                <div v-else-if="value.type === 'boolean' && value.change === '0'" class="form-group col-sm-6">
                  <label>{{ $t('businessDocuments.serialize.' + fileTypeSelected + '.' + value.name) }}</label>

                  <div v-if="serialize[value.name] === '0'">
                    <i class="icon fa fa-check" style="color:green;font-size:30px;"></i>
                    &nbsp;&nbsp;{{ $t('common.status.valid_control_key') }}
                  </div>
                  <div v-else>
                    <i class="icon fa fa-ban" style="color:red;font-size:30px;"></i>&nbsp;&nbsp;
                    <span v-if="serialize[value.name] === '1'">
                      {{ $t('errors.invalid_control_key') }}
                    </span>
                    <span v-else-if="serialize[value.name] === '2'">
                      {{ $t('errors.out_of_date') }}
                    </span>
                    <span v-else-if="serialize[value.name] === '3'">
                      {{ $t('errors.invalid_control_key_out_of_date') }}
                    </span>
                  </div>
                </div>
                <b-col sm="6" class="form-group" v-else>
                  <form-write-group-label-input v-model="serialize[value.name]"
                    :idLabel="$t('businessDocuments.serialize.' + fileTypeSelected + '.' + value.name)">
                  </form-write-group-label-input>
                </b-col>
              </template>
            </template>
          </b-row>
        </form-accordion>

        <hr />
      </div>

      <!-- Recipient Information -->
      <form-accordion :title="$t('contacts.recipient_label')">

        <!-- Recipient Data -->
        <b-row>
          <b-col sm="6" class="form-group">
            <form-dropdown-label-input v-model="selectedContact" isMandatory
              :idLabel="$t('common.nme')"
              :placeholderValue="$t('common.recipient_name')"
              :mandatoryErrorIndicator="recipientNameError"
              valueKey="name" subTextKey="identifier" objectKey="id">
            </form-dropdown-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="recipientEmail" isMandatory
              :idLabel="$t('common.idtfr')" :placeholderValue="$t('common.recipient_email')"
              :mandatoryErrorIndicator="recipientEmailError"
              :regexpErrorIndicator="recipientEmailRegexpError">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>



      <!-- Shared Folders -->
      <hr v-if="sharedFoldersConfig"/>
      <form-accordion :title="$t('businessDocuments.shared_folders')" v-if="sharedFoldersConfig">

        <b-form-group>
          <b-row>
            <b-col class="form-group">
              <b-form-radio v-model="sharedFolderType"
                class="creationFormBtnRadio"
                name="radios-sharedFolderType" value="1">
                {{ $t('businessDocuments.slct_sdr') }}
              </b-form-radio>
            </b-col>
            <b-col>
              <form-write-group-label-input isMandatory
                :idLabel="$t('businessDocuments.slct_sdr')" :hiddenLabel="true"
                :inputType="'listeSelect'" :mandatoryErrorIndicator="folderIdError">
                <select class="form-control" id="sel2" readonly v-model="folderId">
                  <option value="">{{ $t('creation_forms.slct_a_dr') }}</option>
                  <option v-for="(value, index) in jsonOfSharedFolders" :key="index"
                          :value="index">
                    {{ value }}
                  </option>
                </select>
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="form-group">
              <b-form-radio v-model="sharedFolderType"
                class="creationFormBtnRadio"
                name="radios-sharedFolderType" value="2">
                {{ $t('businessDocuments.add_sdr') }}
              </b-form-radio>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="folderName" isMandatory
                :idLabel="$t('businessDocuments.shared_folder_name')" :hiddenLabel="true"
                :placeholderValue="$t('businessDocuments.shared_folder_name')"
                :mandatoryErrorIndicator="folderNameError">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </b-form-group>
      </form-accordion>

      <hr />

      <!-- Comment Zone -->
      <form-accordion :title="$t('common.add_msg')">
        <b-row>
          <b-col class="form-group">
            <textarea v-model="formMessage"
              class="form-control inputAccordionForm"
              :placeholder="$t('common.general_msg')" style="margin-top: 4px;">
            </textarea>
          </b-col>
        </b-row>
      </form-accordion>

      <hr v-if="hasReminderRight()" />

      <b-row v-if="hasReminderRight()">
        <b-col lg="6" class="form-group">
          <b-form-group>
            {{ $t('common.acceptance') }}:
          </b-form-group>
          <b-form-group>
            <b-form-radio v-model="letAcceptWithReminder" name="acceptance-radio" value="1">
              {{ $t('businessDocuments.invoice_accept_reminder_after') }}
              <input :disabled="letAcceptWithReminder !== '1'" class="pl-0 pr-0 miniFormControl" type="text"
                v-model="acceptDaysBeforeReminder"
                @input="acceptDaysBeforeReminder = inputTypingEvent(acceptDaysBeforeReminder, 1, 30, 30)" />
              {{ $t('businessDocuments.invoice_day_after_sent') }}{{', '}}
              {{ $t('businessDocuments.invoice_then_all')}}
              <input :disabled="letAcceptWithReminder !== '1'" class="pl-0 pr-0 miniFormControl" type="text"
                v-model="acceptDaysBetweenReminder"
                @input="acceptDaysBetweenReminder = inputTypingEvent(acceptDaysBetweenReminder, 1, 30, 30)" />
              {{ $t('businessDocuments.invoice_day_and')}}{{' '}}
              {{ $t('businessDocuments.invoice_stop_after')}}
              <input :disabled="letAcceptWithReminder !== '1'" class="pl-0 pr-0 miniFormControl" type="text"
                v-model="acceptMaxNumberReminder"
                @input="acceptMaxNumberReminder = inputTypingEvent(acceptMaxNumberReminder, 0, 10, 0)" />
              {{ $t('businessDocuments.invoice_reminder')}}
            </b-form-radio>
            <b-form-radio v-model="letAcceptWithReminder" name="acceptance-radio" value="0">
              {{ $t('businessDocuments.invoice_accept_no_reminder') }}
            </b-form-radio>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="form-group">
          <b-form-group>
            {{ $t('common.payment') }}:
          </b-form-group>
          <b-form-group>
            <b-form-radio v-model="letPayWithReminder" name="payment-radio" value="1">
              {{ $t('businessDocuments.invoice_payment_reminder_after') }}
              <input :disabled="letPayWithReminder !== '1'" class="pl-0 pr-0 miniFormControl" type="text"
                v-model="payDaysBeforeReminder"
                @input="payDaysBeforeReminder = inputTypingEvent(payDaysBeforeReminder, 1, 30, 30)" />
              {{ $t('businessDocuments.invoice_day_after_sent') }}{{', '}}
              {{ $t('businessDocuments.invoice_then_all')}}
              <input :disabled="letPayWithReminder !== '1'" class="pl-0 pr-0 miniFormControl" type="text"
                v-model="payDaysBetweenReminder"
                @input="payDaysBetweenReminder = inputTypingEvent(payDaysBetweenReminder, 1, 30, 30)" />
              {{ $t('businessDocuments.invoice_day_and')}}{{' '}}{{ $t('businessDocuments.invoice_stop_after')}}
              <input :disabled="letPayWithReminder !== '1'" class="pl-0 pr-0 miniFormControl" type="text"
                v-model="payMaxNumberReminder"
                @input="payMaxNumberReminder = inputTypingEvent(payMaxNumberReminder, 0, 10, 0)" />
              {{ $t('businessDocuments.invoice_reminder')}}
            </b-form-radio>
            <b-form-radio v-model="letPayWithReminder" name="payment-radio" value="0">
              {{ $t('businessDocuments.invoice_payment_no_reminder') }}
            </b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
    <template slot="footerButtons">
      <b-row class="justify-content-start">
        <b-col md="3" offset-md="8" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            @click="sendBusinessDocument">
            <f7-icon fa="paper-plane"></f7-icon>
            {{ $t('businessDocuments.form_document_send_button') }}
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>
<script>
import moment from 'moment'
import documentSerialize from '@/helpers/documentSerialize.json'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formDropdownLabelInput from '@/components/common/formDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import Services from '@/helpers/services'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'

/** @author TLV 05/11/2020
* @brief Component for sending Business Documents
*/
export default {
  name: 'SendDocumentForm',
  components: {
    'form-accordion': FormAccordion,
    'form-dropdown-label-input': formDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      acceptDaysBeforeReminder: this.$engine.settings.documentService.get().daysBeforeReminderAcceptation,
      acceptDaysBetweenReminder: this.$engine.settings.documentService.get().daysBetweenReminderAcceptation,
      acceptMaxNumberReminder: this.$engine.settings.documentService.get().maxNumberReminderAcceptation,
      cloudDocs: '',
      cloudDocsPicker: '',
      letAcceptWithReminder: this.$engine.settings.documentService.get().defaultReminderAcceptationActive,
      letPayWithReminder: this.$engine.settings.documentService.get().defaultReminderPaymentActive,
      // colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      contactSelected: false,
      creationDate: '',
      creationDateError: false,
      currentDocument: {},
      selectedContact: {},
      fileReference: '',
      fieldsTypeMap: {},
      fileArrayError: false,
      fileContent: '',
      fileContentArray: [],
      fileEvent: '',
      fileId: '',
      fileName: '',
      fileNameArray: [],
      fileTypeList: [],
      fileTypeSelected: '',
      fileTypeSelectedError: false,
      folderId: '',
      folderIdError: false,
      folderName: '',
      folderNameError: false,
      formMessage: '',
      hasCloudAttachments: false,
      isSmartphoneOS: false,
      jsonOfContacts: {},
      jsonOfSharedFolders: {},
      loadingFile: false,
      locationTypeFile: '1',
      ocrDone: false,
      payDaysBeforeReminder: this.$engine.settings.documentService.get().daysBeforeReminderPayment,
      payDaysBetweenReminder: this.$engine.settings.documentService.get().daysBetweenReminderPayment,
      payMaxNumberReminder: this.$engine.settings.documentService.get().maxNumberReminderPayment,
      recipientEmail: '',
      recipientEmailError: false,
      recipientEmailRegexpError: false,
      recipientName: '',
      recipientNameError: false,
      requestName: '',
      requestNameError: false,
      selectedRecipient: {},
      serialize: {},
      serializeGet: [],
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig,
      sharedFolderType: '2'
    }
  },
  created () {
    // this.loadDocumentData()

    // Generate fileTypeList from documentSerialize
    let keys = Object.keys(documentSerialize)
    for (var i = 0; i < keys.length; i++) {
      let fileType = {}
      fileType.fileTypeValue = keys[i]
      fileType.fileTypeLabel = documentSerialize[keys[i]].label
      fileType.disabled = documentSerialize[keys[i]].disabled
      this.fileTypeList.push(fileType)
      for (var j = 0; j < documentSerialize[keys[i]].fields.length; j++) {
        let field = documentSerialize[keys[i]].fields[j]
        this.fieldsTypeMap[field.name] = field.type
      }
    }

    this.getCloudFilesList()
    // this.getSharedFolders()
    this.setContactSelectionEvent()
    /** TLV 30/03/2020
    * isSmartphoneOS ne doit être activé QUE si l'utilisateur est sur un smartphone
    * Il ne doit jamais passer à true si l'utilisateur est sur son PC
    * (Pour afficher le bouton "Scan" qui accès à la camera du smartphone)
    */
    if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
      this.isSmartphoneOS = true
      this.locationTypeFile = '0'
    }
  },
  beforeDestroy () {
    this.$engine.services.businessDocuments.currentDocument = {}
  },
  computed: {
    fileNameLabel () {
      if (this.fileName === '') {
        return this.$i18n.t('creation_forms.imprt_file')
      } else {
        return this.fileName
      }
    }
  },
  watch: {
    selectedContact (val) {
      this.recipientName = val.name ? val.name : ''
      this.recipientEmail = val.identifier ? val.identifier : ''
    }
  },
  methods: {
    clearFile () {
      this.fileContent = ''
      this.fileName = ''
      this.fileReference = ''
      this.fileId = ''
      this.fileTypeSelected = ''
    },
    clearFileArrays () {
      this.fileNameArray = []
      this.fileContentArray = []
    },
    executeFacturX (file) {
      let that = this

      // key : IHM reception parameter, value : OCR returned data
      const exchangeData = {
        Name: 'DebtorName',
        Email: 'DebtorMail',
        Iban: 'DebtorIban',
        StreetName: 'DebtorAddress',
        PostalCode: 'DebtorZip',
        TownName: 'DebtorCity',
        CreditorName: 'CreditorName',
        CreditorIban: 'CreditorIban',
        CreditorStreetName: 'CreditorAddress',
        CreditorTownName: 'CreditorCity',
        CreditorPostalCode: 'CreditorZip',
        PaymentDate: 'ExecutionDate',
        Amount: 'AmountTTC',
        Reference: 'InvoiceReference'
      }

      that.$f7.showPreloader(that.$i18n.t('sent.facturx_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return that.$engine.services.facturx(file)
      .then(response => {
        // console.log('--- response', response)
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.facturx_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()

        // Extract data from response
        response = response.data
        // console.log('--- response.data', response)

        // Replace form values with OCR values
        this.debtorZoneCode = this.$engine.bankAccounts.getZoneData('EU')

        for (var key in exchangeData) {
          var ExtractedValue = response[exchangeData[key]]
          if (ExtractedValue) {
            if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
              ExtractedValue = ''
            }
            // Formatting values from OCR to conform to accepted formats
            if (exchangeData[key] === 'Amount') ExtractedValue = ExtractedValue.replace(/,/g, '.') // `comma` -to-> `period`
            else if (exchangeData[key] === 'DebtorIban' || exchangeData[key] === 'CreditorIban') ExtractedValue = ExtractedValue.replace(/ /g, '') // Delete spaces

            that.serialize[key] = ExtractedValue
          }
        }
        this.ocrDone = true
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.file_not_read') + ' ' + err)
        console.log(that.$i18n.t('errors.file_not_read') + ' ' + err)
      })
    },
    // Load file from browser and start OCR, if current parameters allow it
    executeOCR (e) {
      if (e === '' && this.fileEvent === '') {
        return
      } else if (e === '') {
        e = this.fileEvent
      }
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 3000000) {
        var reader = new FileReader()
        reader.onload = (event) => {
          this.fileContent = event.target.result
          this.fileContentArray.push(event.target.result)
          if (this.$engine.settings.get(Services.DOCUMENTSERVICE).ocrActivation === '0' &&
              this.fileContentArray.length > 1) {
            console.log('OCR features are currently under maintenance. Please come again later.')
          } else if (this.fileTypeSelected === '') {
            this.fileEvent = e
          } else {
            this.ocrDone = false
            if (this.fileTypeSelected === 'FACTUR-X') {
              this.executeFacturX(reader.result)
              return
            }
            this.$f7.showPreloader(this.$i18n.t('sent.ocr_loading', {request_type: this.$i18n.t('servicesNames.business_doc_sing')}))
            return this.$engine.services.ocr(
              this.$engine.user.get().id,
              '',
              event.target.result,
              'pdf',
              'scan',
              this.fileTypeSelected
            ).then(response => {
              this.$f7.hidePreloader()
              this.$f7.modal({
                title: this.$i18n.t('sent.ocr_end'),
                text: '<span class="preloader"></span>'
              })
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              response = response.data.ControlsInformations
              let attributes = Object.keys(response)
              for (let i = 0; i < attributes.length; i++) {
                // if (attributes[i] === 'DeliveryDate') {
                //   let dateGetArray = response[attributes[i]].Value.split('-')
                //   this.creationDate = new Date(dateGetArray[2] + '-' + dateGetArray[1] + '-' + dateGetArray[0])
                // } else {
                  // if (this.fieldsTypeMap[attributes[i]] === 'date') {
                  //   let dateGetArray = response[attributes[i]].value.split('-')
                  //   let dateGet = new Date(dateGetArray[2] + '-' + dateGetArray[1] + '-' + dateGetArray[0])
                  //   this.serialize[attributes[i]] = dateGet.toLocaleDateString()
                  // } else {
                this.serialize[attributes[i]] = response[attributes[i]].Value
                  // }
                // }
              }
              this.ocrDone = true
              this.fileEvent = ''
            })
            .catch(err => {
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
              console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
            })
          }
        }
        reader.readAsDataURL(files[0])
        this.fileName = files[0].name
        this.fileNameArray.push(files[0].name)
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.fileName)
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size') + '300 Mo',
          this.$i18n.t('creation_forms.max_size_title'))
      }
      this.$refs.fileButton.value = ''
    },
    filesPicker (e) {
      this.locationTypeFile = '2'
      e.stopPropagation()
      this.cloudDocsPicker.open()
    },
    getCloudFilesList () {
      let that = this
      this.$engine.attachments.getRefresh({
        idAcct: this.$engine.user.get().id
      }).then(response => {
        let filesMap = response.data.docs.map(function (obj) {
          let rObj = {}
          rObj[obj.name] = {
            id: obj.id,
            name: obj.name,
            type: obj.type,
            internalReference: obj.internalReference
          }
          return rObj
        })
        let filesMapObj = Object.assign({}, ...filesMap)
        if (Object.keys(filesMapObj).length > 0) {
          this.hasCloudAttachments = true
        }
        this.cloudDocs = filesMapObj
        this.cloudDocsPicker = this.$f7.picker({
          input: '#bookCloudDocs',
          rotateEffect: true,
          cols: [
            {
              textAlign: 'center',
              values: Object.keys(filesMapObj)
            }
          ],
          onClose: function (p) {
            // var data = []
            // console.log(filesMapObj[p.value])
            that.fileId = filesMapObj[p.value].id
            that.loadCloudFile()
          }
        })
      })
      .catch(err => {
        errorMessageAlert(err, this)
      })
    },
    getSharedFolders (user) {
      this.jsonOfSharedFolders = {}
      let that = this
      this.$engine.services.businessDocuments.update()
      .then(response => {
        let sharedFolders = response.data.groups
        for (var i = 0; i < sharedFolders.length; i++) {
          if (sharedFolders[i].owner === user || sharedFolders[i].correspondent === user) {
            that.jsonOfSharedFolders[sharedFolders[i].idgroup] = sharedFolders[i].reference
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    hasReminderRight () {
      return (this.$engine.user.get().rights.ds_reminder === '1')
    },
    inputTypingEvent (reminderNumber, min, max, defaultValue) { // avec min < 10
      if (isNaN(reminderNumber)) {
        var tmp = ''
        for (var i = 0; i < toString(reminderNumber).length; i++) {
          if (!isNaN(reminderNumber[i])) {
            tmp += reminderNumber[i]
          }
        }
        return tmp
      }
      if (parseInt(reminderNumber) > max) {
        return reminderNumber.substr(0, reminderNumber.length - 1)
      }
      if (parseInt(reminderNumber) < min) {
        return min
      }
      return reminderNumber
    },
    loadCloudFile () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.fileId.toString())
        .then(response => {
          that.loadingFile = false
          that.fileName = response.data.document_name
          that.fileNameArray.push(response.data.document_name)
          that.fileContent = response.data.document_data
          that.fileContentArray.push(response.data.document_data)
          that.fileReference = response.data.internal_reference
          that.fileTypeSelected = response.data.document_type
          this.setSerialize()
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      this.fileId = ''
    },
    // Loading file data, when responding to document requests
    loadDocumentData () {
      this.currentDocument = this.$engine.services.businessDocuments.currentDocument
      if (this.$engine.services.businessDocuments.currentSendbox.reference != null) {
        this.folderName = this.$engine.services.businessDocuments.currentSendbox.reference
      }
      if (Object.keys(this.currentDocument).length) {
        let currentFormAttributes = {
          fileTypeSelected: 'type',
          fileReference: 'internal_reference'
        }
        for (let attribute in currentFormAttributes) {
          if (this.currentDocument[currentFormAttributes[attribute]] != null) {
            this[attribute] = this.currentDocument[currentFormAttributes[attribute]]
          }
        }
        for (let i = 0; i < this.currentDocument.person_information.length; i++) {
          // The sender of a document request becomes the recipient for the response
          if (this.currentDocument.person_information[i].tag === 'SENDER') {
            this.recipientEmail = this.currentDocument.person_information[i].email
            this.recipientName = this.currentDocument.person_information[i].name
          }
        }
      }
    },
    removeFile (filename) {
      let index = this.fileNameArray.indexOf(filename)
      this.fileNameArray.splice(index, 1)
      this.fileContentArray.splice(index, 1)
    },
    scanDocument ($event) {
      /* eslint-disable no-undef */
      let that = this
      this.locationTypeFile = 0
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                executeOCR(e)
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.fileContentArray.push(e.target.result)
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.fileNameArray.push(lab)
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    sendBusinessDocument () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      if (this.creationDate !== '') {
        this.creationDate = moment(this.creationDate).format('YYYY-MM-DD')
      }
      this.$f7.showPreloader(this.$i18n.t('loading.sending_document'))
      let that = this
      let fileContentToSend = that.fileContentArray[0]
      // fileContentToSend = fileContentToSend.substring(fileContentToSend.indexOf(',') + 1, fileContentToSend.length)
      if (that.fileContentArray.length > 1) {
        for (var i = 1; i < that.fileContentArray.length; i++) {
          fileContentToSend += ';' + that.fileContentArray[i]
        }
      }

      let randomIdDoc = 'DOC_' + moment().format('YYYYMMDDHHmmss') + '_' + Math.random().toString(36).substr(2, 6)
      let randomIdGrp = 'GRP_' + moment().format('YYYYMMDDHHmmss') + '_' + Math.random().toString(36).substr(2, 6)
      let jsonToSend = {}
      jsonToSend.Serialize = that.Serialize
      // jsonToSend.person_information = {}

      that.fileReference = that.requestName

      let jsonToCreate = {
        Receiver: that.recipientEmail,
        AttachmentId: randomIdDoc,
        AttachmentName: that.requestName,
        AttachmentReference: that.fileReference,
        AttachmentDate: that.creationDate,
        AttachmentType: that.fileTypeSelected,
        AttachmentData: fileContentToSend,
        AttachmentOthers: jsonToSend,
        AttachmentDescription: that.formMessage
      }
      if (that.sharedFolderType === '1') {
        jsonToCreate.IdGroup = that.folderId
        jsonToCreate.GroupId = randomIdGrp
        jsonToCreate.GroupLabelReference = that.jsonOfSharedFolders[that.folderId]
      } else if (that.sharedFolderType === '2') {
        jsonToCreate.GroupId = randomIdGrp
        jsonToCreate.GroupLabelReference = that.folderName
      }
      that.$engine.services.businessDocuments.create(jsonToCreate)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.document_sent'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/inbox/'})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    // Event for retrieving selected contact from contact selection button
    setContactSelectionEvent () {
      let contacts = this.$engine.contacts.get()
      this.jsonOfContacts = {}
      for (var i = 0; i < contacts.length; i++) {
        this.jsonOfContacts[contacts[i].id] = contacts[i]
      }
      let that = this
      // Retrieve selected contact id and load associated data
      this.$bus.$on('refresh-debtor-contact-list', (data) => {
        that.selectedRecipient = that.jsonOfContacts[data]
        that.recipientName = that.selectedRecipient.name
        that.recipientEmail = that.selectedRecipient.identifier
        that.contactSelected = true
        // Default folder name is the recipient name
        that.folderName = that.recipientName
      })
      if (this.sharedFoldersConfig) {
        this.getSharedFolders(that.selectedRecipient.identifier)
      }
    },
    setSerialize () {
      this.serialize = {}
      if (this.fileTypeSelected !== '') {
        this.serializeGet = documentSerialize[this.fileTypeSelected].fields
        for (var i = 0; i < this.serializeGet.length; i++) {
          this.serialize[this.serializeGet[i].name] = ''
        }
        this.executeOCR('')
      } else {
        this.serializeGet = []
      }
    },
    showFileSelectionWindow (fileType) {
      this.locationTypeFile = '1'
      if (fileType === '1') {
        this.Dom7(this.Dom7('.local-file-input')[this.Dom7('.local-file-input').length - 1]).click()
      }
    },
    validateForm () {
      let flagsList = {
        'recipientName': false,
        'recipientEmail': false,
        'folderId': false,
        'folderName': false,
        'fileTypeSelected': false,
        'fileNameArray': false
      }
      let mandatoryValues = ['recipientName', 'recipientEmail', 'fileTypeSelected', 'requestName']
      let regexpValues = {
        'recipientEmail': 'Email'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      if (this.fileNameArray.length === 0) {
        this.fileArrayError = true
        flagsList.fileNameArray = true
      }
      if (this.sharedFoldersConfig && this.sharedFolderType === '1' && this.folderId === '') {
        this.folderIdError = true
        flagsList.folderId = true
        this.folderNameError = false
        flagsList.folderName = false
      } else if (this.sharedFoldersConfig && this.sharedFolderType === '2' && this.folderName === '') {
        this.folderNameError = true
        flagsList.folderName = true
        this.folderIdError = false
        flagsList.folderId = false
      }
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    }
  }
}
</script>



// WEBPACK FOOTER //
// SendDocumentTemplate.vue?4977c634